import { createReducer } from '../../../utils/fsa';
import { openPopup, popupClosed } from '../action_creators/popup';
import { ReactNode } from 'react';

export interface IPopupContent {
  (): ReactNode;
}

export interface IPopup {
  content: IPopupContent;
  onClose?: (getState?: <IApplicationState>() => IApplicationState) => void;
}

export interface IPopupState {
  openedPopups: IPopup[];
}

export default createReducer<IPopupState>()

  .on(openPopup, (state, action) => {
    return {
      openedPopups: [action.payload].concat(state.openedPopups),
    };
  })

  .on(popupClosed, (state, action) => {
    return {
      openedPopups: state.openedPopups.slice(1),
    };
  })

  .build({
    openedPopups: [],
  });



// WEBPACK FOOTER //
// ./src/bundles/popup/reducers/popup.ts